import Artiste from "./Artiste";
export default Artiste;
